<template>
  <div class="flex-center p-10">
    <p>Oops! Something went wrong. Please try again.</p>
  </div>
</template>
